import * as d3 from 'd3';
import { ITimeScale } from './ITimeScale';

export class TimeScale implements ITimeScale {

    private _width: number;
    private _beginDate: Date;
    private _endDate: Date;
    private _scale: d3.time.Scale<number, number>;

    constructor(width: number, beginDate: any, endDate: any) {
        this._beginDate = new Date(beginDate);
        this._endDate = new Date(endDate);
        this.init();
        this.size(width);
    }

    private init() {
        this._scale = d3.time.scale()
            .domain([this._beginDate, this._endDate]);

    }

    size(value?: number): number {
        if (value) {
            this._width = value;
            this._scale.range([0, this._width]);
        }
        return this._width;
    }

    update(beginDate: any, endDate: any) {
        this._scale.domain([beginDate, endDate]);
    }

    scale(): d3.time.Scale<number, number> {
        return this._scale;
    }

}